var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 11.63a.563.563 0 01-.562-.563V6.625a.563.563 0 011.125 0v4.442c0 .31-.252.562-.563.562zM7.997 5.5a.553.553 0 01-.396-.166.553.553 0 010-.793.579.579 0 01.793-.003.564.564 0 01-.397.962z",
    fill: "#636366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.979 15.312c-.64 0-1.274-.083-1.886-.248A7.365 7.365 0 01.84 9.506a7.368 7.368 0 012.673-7.28 7.361 7.361 0 014.5-1.528c1.133 0 2.257.263 3.252.76a7.373 7.373 0 014.045 6.544c0 2.24-1.057 4.4-2.828 5.776a7.366 7.366 0 01-4.503 1.534zm.035-13.49c-1.386 0-2.74.46-3.81 1.292A6.235 6.235 0 001.94 9.275a6.231 6.231 0 004.445 4.702 6.237 6.237 0 005.406-1.087 6.234 6.234 0 002.393-4.888 6.24 6.24 0 00-3.423-5.537 6.173 6.173 0 00-2.748-.642z",
    fill: "#636366"
  })));
}

export default SvgIconWarningCircle;